import { render, staticRenderFns } from "./AdminDashIntro.vue?vue&type=template&id=04c934a4&scoped=true"
import script from "./AdminDashIntro.vue?vue&type=script&lang=js"
export * from "./AdminDashIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c934a4",
  null
  
)

export default component.exports